import { connect } from 'react-redux';
import Component from './component';
import setOpenNavigationDrawerAction from '../../actions/navigationdrawer/set';
import setOpenNotificationDrawerAction from '../../actions/notificationdrawer/set';
import setThemeAction from '../../actions/theme/set';
// import debug from '../../services/debug';

const mapStateToProps = (state) => ({
  // session: state.session.get('data'),
  contact: state.contacts.get('set'),
  prefersDarkMode: state.theme.get('prefersDarkMode'),
});

const mapDispatchToProps = (dispatch) => ({
  handleOpenNavigationDrawer: async (e, isOpen) => {
    if (e) e.preventDefault();
    await dispatch(await setOpenNavigationDrawerAction(isOpen));
  },
  handleOpenNotificationDrawer: async (e, isOpen) => {
    if (e) e.preventDefault();
    await dispatch(await setOpenNotificationDrawerAction(isOpen));
  },
  handleGlobalThemeMode: async (themeMode) => {
    // Call Action here ---
    await dispatch(await setThemeAction(themeMode));
  },
});

export default connect(mapStateToProps, mapDispatchToProps)(Component);
